import { Check, Package, Truck, Wallet, AlertTriangle } from "lucide-react";
import { DocPage, Section, Demo, SpecTable, DoDont } from "../../components/DocChrome";

export function IconographyPage() {
    return (
        <DocPage
            title="Iconography"
            description="Lucide React is the Workspace icon library. Stroke weight stays consistent."
        >
            <Section title="Library">
                <p>
                    Use <code>lucide-react</code>. Prefer the thin <code>Icon</code> wrapper from{" "}
                    <code>@maeiz/ui</code> for size and a11y defaults.
                </p>
                <Demo>
                    <div className="flex flex-wrap gap-6 text-primary">
                        <Check size={20} />
                        <Package size={20} />
                        <Truck size={20} />
                        <Wallet size={20} />
                        <AlertTriangle size={20} className="text-warning" />
                    </div>
                </Demo>
            </Section>
            <Section title="Sizes">
                <SpecTable
                    rows={[
                        ["sm", "16px — inline with caption"],
                        ["md", "20px — default with body / buttons"],
                        ["lg", "24px — nav / empty states"],
                        ["xl", "32px+ — illustrative empty only"],
                    ]}
                />
            </Section>
            <DoDont
                doItems={[
                    "Match icon size to control size",
                    "Mark decorative icons aria-hidden",
                    "Use status icons with text",
                ]}
                dontItems={[
                    "Mix icon libraries",
                    "Rely on color alone for status",
                    "Use emoji as UI icons",
                ]}
            />
        </DocPage>
    );
}
